module.exports = __webpack_public_path__ + "static/media/BJ.d634bcf7.svg";